import * as React from 'react';
import classNames from 'clsx';
import {
  formatClassNames,
  getDataAttributes,
} from '@wix/editor-elements-common-utils';
import { useTikTokPlayerApi } from './hooks/useTikTokPlayerApi';
import semanticClassNames from '../SocialPlayerTikTok.semanticClassNames';
import type { ISocialPlayerTikTokProps } from '../SocialPlayerTikTok.types';
import {
  extractVideoIdFromUrl,
  generateVideoUrl,
} from './SocialPlayerTikTok.utils';
import { TestIds } from '../constants';
import styles from './SocialPlayerTikTok.module.scss';

const SocialPlayerTikTok: React.FC<ISocialPlayerTikTokProps> = ({
  id,
  className,
  customClassNames = [],
  url,
  description,
  autoPlay = true,
  loop = false,
  mute = true,
  enabledControls = true,
  enabledTitle = true,
  startTime,
  endTime,
  onMouseEnter,
  onMouseLeave,
  ...props
}) => {
  const { setPlayerRef } = useTikTokPlayerApi({
    startTime,
    endTime,
    onPlayerReady: React.useCallback(
      api => {
        if (autoPlay || mute) {
          api.mute();
        }
      },
      [autoPlay, mute],
    ),
  });

  const rootClass = classNames(
    styles.root,
    className,
    formatClassNames(semanticClassNames.root, ...customClassNames),
  );

  return (
    <div
      id={id}
      className={rootClass}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
      {...getDataAttributes(props)}
    >
      <div className={styles.alignmentWrapper}>
        <iframe
          data-testid={TestIds.viewer.iframe}
          loading="lazy"
          ref={setPlayerRef}
          title={description}
          width="100%"
          height="100%"
          src={generateVideoUrl({
            videoId: extractVideoIdFromUrl(url),
            options: {
              enabledControls,
              loop,
              autoPlay,
              enabledTitle,
            },
          })}
        />
      </div>
    </div>
  );
};

export default SocialPlayerTikTok;
